/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AaiServer } from '../../asyncapi/models/AaiServer';
import { Aai20Document } from '../../asyncapi/v2/models/Aai20Document';
import { Aai20Server } from '../../asyncapi/v2/models/Aai20Server';
import { AbstractCommand } from '../AbstractCommand';
import { ModelUtils } from '../util/ModelUtils';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { NodeCompat } from '../../compat/NodeCompat';
import { Constants } from '../../core/Constants';
import { Document } from '../../core/models/Document';
import { Server } from '../../core/models/common/Server';
import { MarshallCompat } from '../../compat/MarshallCompat';
import { Node } from '../../core/models/Node';

/**
 * A command used to create a new server in an aaidocument.
 * @author c.desc2@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class NewServerCommand_Aai20 extends AbstractCommand {
    public _server : any;

    public _serverName : string;

    public _serverExisted : boolean;

    public constructor(parent? : any, server? : any) {
        if(((parent != null && parent instanceof <any>Aai20Document) || parent === null) && ((server != null && server instanceof <any>Aai20Server) || server === null)) {
            let __args = arguments;
            super();
            if(this._server===undefined) this._server = null;
            if(this._serverName===undefined) this._serverName = null;
            if(this._serverExisted===undefined) this._serverExisted = false;
            if(this._server===undefined) this._server = null;
            if(this._serverName===undefined) this._serverName = null;
            if(this._serverExisted===undefined) this._serverExisted = false;
            (() => {
                this._serverName = server.getName();
                this._server = Library.writeNode(server);
            })();
        } else if(parent === undefined && server === undefined) {
            let __args = arguments;
            super();
            if(this._server===undefined) this._server = null;
            if(this._serverName===undefined) this._serverName = null;
            if(this._serverExisted===undefined) this._serverExisted = false;
            if(this._server===undefined) this._server = null;
            if(this._serverName===undefined) this._serverName = null;
            if(this._serverExisted===undefined) this._serverExisted = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[NewServerCommand_Aai20] Executing.");
        let parent : Aai20Document = <Aai20Document>document;
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        let servers : any = parent.servers;
        if(this.isNullOrUndefined(servers)) {
            servers = <any>({});
            NodeCompat.setProperty(parent, Constants.PROP_SERVERS, servers);
        }
        let server : AaiServer = parent.createServer$java_lang_String(this._serverName);
        Library.readNode(this._server, server);
        if(this.serverAlreadyExists(parent)) {
            this._serverExisted = true;
            return;
        } else {
            /* put */(servers[this._serverName] = server);
            this._serverExisted = false;
        }
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[NewServerCommand_Aai20] Reverting.");
        if(this._serverExisted) {
            return;
        }
        let parent : Aai20Document = <Aai20Document>document;
        if(this.isNullOrUndefined(parent) || this.isNullOrUndefined(parent.servers)) {
            return;
        }
        let servers : any = parent.servers;
        let server : Server = /* get */((m,k) => m[k]===undefined?null:m[k])(servers, this._serverName);
        if(this.isNullOrUndefined(server)) {
            return;
        }
        /* remove */(map => { let deleted = servers[this._serverName];delete servers[this._serverName];return deleted;})(servers);
        if(/* size */Object.keys(servers).length === 0) {
            NodeCompat.setProperty(parent, Constants.PROP_SERVERS, null);
        }
    }

    /**
     * Returns true if a server with the same name already exists in the parent.
     * @param {Aai20Document} parent
     * @return {boolean}
     * @private
     */
    /*private*/ serverAlreadyExists(parent : Aai20Document) : boolean {
        return ModelUtils.isDefined(/* get */((m,k) => m[k]===undefined?null:m[k])(parent.servers, this._serverName));
    }
}
NewServerCommand_Aai20["__class"] = "io.apicurio.datamodels.cmd.commands.NewServerCommand_Aai20";
NewServerCommand_Aai20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




